var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Base } from '@or-sdk/base';
import { UsageCostApi, CustomersApi, CustomerForPaymentsApi, VendorsApi, VendorMappingApi, PaymentProvidersApi, SkusApi, EnvironmentsApi, SkuMappingApi, ReportingDatabasesApi, ContractsApi, PatternsApi, AccountsApi, SageApi, CustomSkuApi, FlowsApi, PrepaymentsApi, TiersApi, CustomerUsageApi, SubscriptionsApi, BillingPlansApi, CreditsApi, EngineApi, ProcessingStatusesApi, TransactionsApi, CategoriesApi, EmployeesApi, DiscoveryApi, ThresholdAlertsApi, ThresholdSettingsApi, DataReconciliationApi, AuditApi, CronSettingsApi, ContactsApi, ContactSkillsApi, ContactTypesApi, ProgressiveTiersApi, PaymentSettingsApi, PaymentEngineApi, PermissionsProxyApi, UsersApi, PollingApi, ErroredSkusApi, CustomerAccountActionsApi, LoginAuditApi, } from './api';
import InvoicingApi from './api/invoicingApi';
import { SERVICE_KEY } from './constants';
import paramsSerializer from './utils/paramSerializer';
export class Billing extends Base {
    constructor(params) {
        const { client, env, token, discoveryUrl, serviceUrl, allowSuspended, } = params;
        super({
            token,
            discoveryUrl,
            serviceUrl,
            serviceKey: SERVICE_KEY,
            paramSerializer: paramsSerializer,
        });
        this.client = client;
        this.env = env;
        this.allowSuspended = allowSuspended;
        const apiCall = this.callApi.bind(this);
        this.usageCostApi = new UsageCostApi(apiCall);
        this.customersApi = new CustomersApi(apiCall);
        this.customerForPaymentsApi = new CustomerForPaymentsApi(apiCall);
        this.vendorsApi = new VendorsApi(apiCall);
        this.vendorMappingApi = new VendorMappingApi(apiCall);
        this.paymentProvidersApi = new PaymentProvidersApi(apiCall);
        this.skusApi = new SkusApi(apiCall);
        this.environmentsApi = new EnvironmentsApi(apiCall);
        this.skuMappingApi = new SkuMappingApi(apiCall);
        this.reportingDatabasesApi = new ReportingDatabasesApi(apiCall);
        this.contractsApi = new ContractsApi(apiCall);
        this.patternsApi = new PatternsApi(apiCall);
        this.accountsApi = new AccountsApi(apiCall);
        this.sageApi = new SageApi(apiCall);
        this.customSkuApi = new CustomSkuApi(apiCall);
        this.flowsApi = new FlowsApi(apiCall);
        this.prepaymentsApi = new PrepaymentsApi(apiCall);
        this.tiersApi = new TiersApi(apiCall);
        this.customersUsageApi = new CustomerUsageApi(apiCall);
        this.billingPlansApi = new BillingPlansApi(apiCall);
        this.subscriptionsApi = new SubscriptionsApi(apiCall);
        this.creditsApi = new CreditsApi(apiCall);
        this.engineApi = new EngineApi(apiCall);
        this.processingStatusesApi = new ProcessingStatusesApi(apiCall);
        this.transactionsApi = new TransactionsApi(apiCall);
        this.categoriesApi = new CategoriesApi(apiCall);
        this.employeesApi = new EmployeesApi(apiCall);
        this.discoveryApi = new DiscoveryApi(apiCall);
        this.thresholdAlertsApi = new ThresholdAlertsApi(apiCall);
        this.thresholdSettingsApi = new ThresholdSettingsApi(apiCall);
        this.dataReconciliationApi = new DataReconciliationApi(apiCall);
        this.auditApi = new AuditApi(apiCall);
        this.cronSettingsApi = new CronSettingsApi(apiCall);
        this.contactsApi = new ContactsApi(apiCall);
        this.contactSkillsApi = new ContactSkillsApi(apiCall);
        this.contactTypesApi = new ContactTypesApi(apiCall);
        this.progressiveTiersApi = new ProgressiveTiersApi(apiCall);
        this.paymentSettingsApi = new PaymentSettingsApi(apiCall);
        this.paymentEngineApi = new PaymentEngineApi(apiCall);
        this.invoicingApi = new InvoicingApi(apiCall);
        this.permissionsProxyApi = new PermissionsProxyApi(apiCall);
        this.usersApi = new UsersApi(apiCall);
        this.pollingApi = new PollingApi(apiCall);
        this.erroredSkusApi = new ErroredSkusApi(apiCall);
        this.customerAccountActionsApi = new CustomerAccountActionsApi(apiCall);
        this.loginAuditApi = new LoginAuditApi(apiCall);
    }
    callApi(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const makeRequest = () => this.callApiV2(Object.assign(Object.assign({}, params), { customHeaders: {
                    'x-exchange-token': this.exchangeToken,
                } }));
            if (this.env && this.client) {
                if (!this.exchangeToken) {
                    yield this.getExchangeToken();
                }
                try {
                    return yield makeRequest();
                }
                catch (error) {
                    if (error.message === 'Token expired') {
                        try {
                            yield this.getExchangeToken();
                            return yield makeRequest();
                        }
                        catch (error) {
                            throw error;
                        }
                    }
                    else {
                        throw error;
                    }
                }
            }
            else {
                try {
                    return this.callApiV2(params);
                }
                catch (error) {
                    throw error instanceof Error ? new Error(error.message) : { message: 'Unexpected error' };
                }
            }
        });
    }
    getExchangeToken() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const result = yield this.callApiV2({
                    method: 'POST',
                    route: 'auth/token',
                    data: {
                        token: this.getToken(),
                        client: this.client,
                        env: this.env,
                        allowSuspended: this.allowSuspended,
                    },
                });
                this.exchangeToken = result.exchangeToken;
            }
            catch (err) {
                throw err.message ? new Error(err.message) : new Error('Unauthorized');
            }
        });
    }
}
//# sourceMappingURL=Billing.js.map